<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'

import Widget from './widget'
import Multiselect from 'vue-multiselect'


/**
 * Dashboard-1 Component
 */
export default {
  page: {
    title: '360MDR Real Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    Widget,
    Multiselect
  },
  props: {
    name: {
      type: String,
      default: 'main.json'
    }
  },
  data() {
    return {
      dateUnit: 'month,181',
      dashboard: {
        "widgets": [
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-COLBOG01",
            "source": "/pan/ngfw/agg/uptime/[[DateUnit]]?collection=pan_ngfw_uptime&variable=datetime&action=sum&sumvar=uptime&start=0&match=device,COLC-FW-PAN-COLBOG01&limit=[[DateLimit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-COLBOG02",
            "source": "/pan/ngfw/agg/uptime/[[DateUnit]]?collection=pan_ngfw_uptime&variable=datetime&action=sum&sumvar=uptime&start=0&match=device,COLC-FW-PAN-COLBOG02&limit=[[DateLimit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-FUG-01",
            "source": "/pan/ngfw/agg/uptime/[[DateUnit]]?collection=pan_ngfw_uptime&variable=datetime&action=sum&sumvar=uptime&start=0&match=device,COLC-FW-PAN-FUG-01&limit=[[DateLimit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-FUG-02",
            "source": "/pan/ngfw/agg/uptime/[[DateUnit]]?collection=pan_ngfw_uptime&variable=datetime&action=sum&sumvar=uptime&start=0&match=device,COLC-FW-PAN-FUG-02&limit=[[DateLimit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-USAMFD01",
            "source": "/pan/ngfw/agg/uptime/[[DateUnit]]?collection=pan_ngfw_uptime&variable=datetime&action=sum&sumvar=uptime&start=0&match=device,COLC-FW-PAN-USAMFD01&limit=[[DateLimit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-USAMFD02",
            "source": "/pan/ngfw/agg/uptime/[[DateUnit]]?collection=pan_ngfw_uptime&variable=datetime&action=sum&sumvar=uptime&start=0&match=device,COLC-FW-PAN-USAMFD02&limit=[[DateLimit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000,
          },
        ]
      },
      // jsonDef: '@src/router/views/pages/dashboard/data/'+name,
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      startEpoch: 0,
      endEpoch: 99999999999,
      dateTimeUnitsOptions: [
        { value: 'month,181', text: 'Months' },
        { value: 'day,8', text: '7 Days' },
        { value: 'day,31', text: '30 Days' },
        { value: 'day,61', text: '60 Days' },
      ],
    }
  },
  computed: {

  },
  mounted () {

    // console.log(this.jsonDef)
  },
  methods: {
    changeDateUnit(source) {
      const [unit, limit] = this.dateUnit.split(',')
      let result = source.replace('\[\[DateUnit\]\]', unit)
      result = result.replace('\[\[DateLimit\]\]', limit)
      return result
    },
    changeDataLabels() {
      const [unit, limit] = this.dateUnit.split(',')
      if (parseInt(limit) > 10 && unit === 'day') {
        return false
      } else {
        return true
      }
    }
  },
}
</script>

<template>
  <Layout>
    <div class="container" style="max-width: 1420px !important;">
      <div class="row page-title align-items-center">
        <b-form-select
            v-model="dateUnit"
            :options="dateTimeUnitsOptions"
            placeholder="Time Unit"
        >
        </b-form-select>
      </div>
      <div class="row">
        <template v-for="(widget, index) in dashboard.widgets">
          <!-- <div :class="widget.cols">
            <span><h5>{{ widget.name }}</h5></span>
            <b-card no-body class="text-center" style="line-height:300px">
              {{ widget.component }}
            </b-card>
          </div> -->
          <Widget v-bind:key="dateUnit+index"
                  :title="widget.name"
                  :component="widget.component"
                  :source="changeDateUnit(widget.source)"
                  :series="widget.series"
                  :cols="widget.cols"
                  :trend="widget.trend"
                  :wclass="widget.class"
                  :type="widget.type"
                  :labels="widget.labels"
                  :cardStyle="widget.cardStyle"
                  :categories="widget.categories"
                  :colors="widget.colors"
                  :colorsByLabel="widget.colorsByLabel"
                  :range="widget.range"
                  :start="startEpoch"
                  :end="endEpoch"
                  :auxBool="changeDataLabels()"
          />
        </template>
      </div>
    </div>
  </Layout>
</template>
